import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';

const Container = styled.div`
  display: none;

  &[aria-current='true'] {
    display: flex;
    place-items: flex-start;
    place-content: center;
    position: absolute;
    z-index: 1;
    top: var(--headerHeight);
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: calc(100vh - var(--headerHeight));
    height: calc(100dvh - var(--headerHeight));
    background-color: ${rgba(brand.black, 0.6)};
    padding: 8px;
    width: 100%;

    @media ${from(Device.DesktopSmall)} {
      place-content: flex-end;
    }
  }
`;

const Inner = styled.div`
  padding: 10px;
  width: calc(100vw - (var(--headerPadding) * 2));
  background-color: ${brand.white};
  border-radius: 12px;

  @media ${from(Device.DesktopSmall)} {
    max-width: var(--searchWidth);
    margin-right: 100px;
  }
`;

const List = styled.ul``;

const Item = styled.li``;

const Link = styled.a`
  display: flex;
  place-items: center;
  gap: ${fluid(10, 20)};
  padding: 10px;
  border-radius: 12px;

  &:hover,
  &:focus-visible {
    background-color: ${brand.grey[97]};
  }
`;

const ImageWrapper = styled.div`
  max-width: ${fluid(65, 85)};
  flex: 1 0 ${fluid(65, 85)};
  border-radius: 12px;
  overflow: hidden;
`;

const Content = styled.div``;

const ModelCode = styled.div`
  ${fonts.helvetica['53-extended']}
  font-size: ${fluid(10, 14)};
  color: ${brand.red.dark};
  text-transform: uppercase;
  margin-bottom: 4px;
`;

const Name = styled.div`
  ${fonts.helvetica['83-heavy-extended']}
  font-size: ${fluid(12, 16)};
  line-height: 1.4em;
  color: ${brand.black};
  text-transform: uppercase;
`;

const SearchTypeaheadStyles = {
  Container,
  Inner,
  List,
  Item,
  Link,
  ImageWrapper,
  Content,
  ModelCode,
  Name,
};

export default SearchTypeaheadStyles;
